import { InfoCircleIcon } from '@approvalmax/ui';
import { Flex, Grid } from '@approvalmax/ui/src/components';
import { memo } from 'react';

import { SummaryLineProps } from './SummaryLine.types';

export const SummaryLine = memo<SummaryLineProps>((props) => {
    const { label, value1, value2, warning = false, mode = 'compact' } = props;

    const width = mode === 'wide' ? 360 : 192;
    const gap = mode === 'wide' ? 0 : 16;
    const spacing = mode === 'wide' ? '0' : '16';

    return (
        <Flex alignItems='center' justifyContent='end' wrap={false} spacing={spacing}>
            {label && (
                <Flex alignItems='center' spacing='4'>
                    {warning && <InfoCircleIcon width={12} height={12} color='midnight70' />}

                    {label}
                </Flex>
            )}

            <Grid width={width} gridTemplateColumns={value2 ? '1fr 1fr' : '1fr'} gap={gap}>
                <Flex justifyContent='end'>{value1}</Flex>

                {value2 && <Flex justifyContent='end'>{value2}</Flex>}
            </Grid>
        </Flex>
    );
});

SummaryLine.displayName = 'SummaryLine';
